(() => {
  if (window.FeaturedProductSlider) return;

  class FeaturedProductSlider {
    constructor(parent) {
      if (!parent) return;

      this.parent = parent;
      this.init();
    }

    init() {
      const elements = this.parent.querySelectorAll('.featuredProductSlider');

      elements.forEach((item) => {
        if (item.dataset.initialized === 'true') return;
        item.dataset.initialized = 'true';
        this.swiper(item);
      });
    }

    swiper(element) {
      let loop = element.dataset.loop === 'true';
      let autoplay = element.dataset.autoplay === 'true';
      let time = parseInt(element.dataset.autoplayTime || 0) * 1000;
      let navigation = element.dataset.navigation === 'true';
      let slidesPerView = parseFloat(element.dataset.slidePerView);
      let elId = element.dataset.id;

      if (window.innerWidth < 749) {
        slidesPerView = parseFloat(element.dataset.mSlidePerView) + 0.5;
      }

      if (window.innerWidth >= 750 && window.innerWidth < 990) {
        slidesPerView = 2.5;
      }

      navigation = navigation
        ? {
            nextEl: `.${elId} .swiper-button-next`,
            prevEl: `.${elId} .swiper-button-prev`,
          }
        : false;

      autoplay = autoplay
        ? {
            delay: time,
            disableOnInteraction: false,
          }
        : false;

      new Swiper(element, {
        loop,
        slidesPerView,
        spaceBetween: 15,
        navigation,
        autoplay,
        breakpoints: {
          768: { spaceBetween: 15 },
          990: { spaceBetween: 14 },
        },
      });
    }
  }

  window.FeaturedProductSlider = FeaturedProductSlider;

  const init = () => {
    document
      .querySelectorAll('.featured-product-slider')
      .forEach((section) => new FeaturedProductSlider(section));
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
